import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP6ChurnedNew: FaireAdCampaignEntity = {
  token: "camp_p6_churned_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_p6_churned",
  segment: "NEW_MARKETPLACE",
  status: "STOPPED",
  monthlyBudgetDollars: 1800,
  startedRunningAt: "2024-03-01",
  stoppedRunningAt: "2026-07-01",
  segmentMetrics: {
    numCustomersAcquired: 275,
    salesDollars: 120974,
    totalAdsSpendDollars: 39906,
    cpaDollars: 145,
    bestEstimateSalesDollars: 120974,
    bestEstimateRoas: 3.03,
  },
  topCustomers: [
    {
      retailerName: "Bauble Bar Boutique",
      storeType: "Boutique",
      location: "Scottsdale, AZ",
      totalOrders: 4,
      totalAmountDollars: 1520,
      lastOrderedAt: "2026-06-21",
    },
    {
      retailerName: "Coastal Charm",
      storeType: "Gift shop",
      location: "Naples, FL",
      totalOrders: 2,
      totalAmountDollars: 660,
      lastOrderedAt: "2026-05-30",
    },
  ],
  performancePeriodTokens: [
    "perf_p6_churned_new_202506",
    "perf_p6_churned_new_202507",
    "perf_p6_churned_new_202508",
    "perf_p6_churned_new_202509",
    "perf_p6_churned_new_202510",
    "perf_p6_churned_new_202511",
    "perf_p6_churned_new_202512",
    "perf_p6_churned_new_202601",
    "perf_p6_churned_new_202602",
    "perf_p6_churned_new_202603",
    "perf_p6_churned_new_202604",
    "perf_p6_churned_new_202605",
    "perf_p6_churned_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
